import styled from 'styled-components';

export const ActionIcon = styled.i`
  margin-left: 10px;
  color: ${(props) => props.color || 'inherit'};
  font-size: 12px;
  transition: color 0.2s;
`;

export const ActionButton = styled.button`
  padding: 5px 10px;
  display: flex;
  align-items: center;
  color: ${(props) => props.color || '#6c60f6'};
  font-size: 12px;
  border: none;
  background-color: transparent;
  cursor: pointer;
  transition: color 0.2s;

  &:disabled {
    color: #b0a9f9;
    cursor: not-allowed;

    ${ActionIcon} {
      color: inherit;
    }
  }
`;
